/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: iK-mgfsgp95e

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { StateProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/StateProvider/StateProvider"; // plasmic-import: OaGu0RHjgthJ/codeComponent
import { DebounceProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/DebounceProvider/DebounceProvider"; // plasmic-import: mybfJQ3wXE2a/codeComponent
import { OnChangeProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/OnChangeProvider/OnChangeProvider"; // plasmic-import: aQR8NTRfsmne/codeComponent
import MultiFactorAuthModal from "../../MultiFactorAuthModal"; // plasmic-import: t5CKmWfTpe_O/component
import News from "../../News"; // plasmic-import: R99muOTbbJZX/component
import LoginForm from "../../LoginForm"; // plasmic-import: JVoKw0cfx-VJ/component
import LoginTroubleshootingModal from "../../LoginTroubleshootingModal"; // plasmic-import: jOhB8EyLNa7v/component
import ContactModal from "../../ContactModal"; // plasmic-import: 2lCEPY1ezZ3j/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicLogIn.module.css"; // plasmic-import: iK-mgfsgp95e/css

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    title:
      "Medical Education Login | Innovative Learning Management - MyEvaluations | Secure Account Management",
    description:
      "Secure login to manage your GME, PA, or Nursing educational programs with MyEvaluations.",
    openGraph: {
      title:
        "Medical Education Login | Innovative Learning Management - MyEvaluations | Secure Account Management",
      description:
        "Secure login to manage your GME, PA, or Nursing educational programs with MyEvaluations."
    },
    twitter: {
      card: "summary" as const,
      title:
        "Medical Education Login | Innovative Learning Management - MyEvaluations | Secure Account Management",
      description:
        "Secure login to manage your GME, PA, or Nursing educational programs with MyEvaluations."
    },
    alternates: { canonical: "https://www.myevaluations.com/login" }
  };
}

createPlasmicElementProxy;

export type PlasmicLogIn__VariantMembers = {};
export type PlasmicLogIn__VariantsArgs = {};
type VariantPropType = keyof PlasmicLogIn__VariantsArgs;
export const PlasmicLogIn__VariantProps = new Array<VariantPropType>();

export type PlasmicLogIn__ArgsType = {};
type ArgPropType = keyof PlasmicLogIn__ArgsType;
export const PlasmicLogIn__ArgProps = new Array<ArgPropType>();

export type PlasmicLogIn__OverridesType = {
  root?: Flex__<"div">;
  isAutoSave?: Flex__<typeof StateProvider>;
  isAutoLogin?: Flex__<typeof StateProvider>;
  debounceProvider?: Flex__<typeof DebounceProvider>;
  webFallbackRedirect?: Flex__<typeof OnChangeProvider>;
  multiFactorAuthModal?: Flex__<typeof MultiFactorAuthModal>;
  desktop?: Flex__<"div">;
  content?: Flex__<"div">;
  loginForm?: Flex__<typeof LoginForm>;
  mobile?: Flex__<"div">;
  loginForm2?: Flex__<typeof LoginForm>;
  loginTroubleshootingModal?: Flex__<typeof LoginTroubleshootingModal>;
  contactModal?: Flex__<typeof ContactModal>;
};

export interface DefaultLogInProps {}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicLogIn__RenderFunc(props: {
  variants: PlasmicLogIn__VariantsArgs;
  args: PlasmicLogIn__ArgsType;
  overrides: PlasmicLogIn__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "loginTroubleshootingModal.open",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "isAutoSave.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "isAutoLogin.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "isLoggingWithToken",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "usernameParam",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      },
      {
        path: "contactModal.open",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "multiFactorAuthModal.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "multiFactorAuthModal.factors",
        type: "private",
        variableType: "array",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => []
      },
      {
        path: "multiFactorAuthModal.isChallengeSubmitting",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "mobileAppRedirect",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ({})
      },
      {
        path: "multiFactorAuthModal.methodSelected",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "multiFactorAuthModal.cooldown",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ({
          Email: 0,
          SMS: 0,
          Password: 0
        })
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const pageMetadata = generateDynamicMetadata(
    wrapQueriesWithLoadingProxy({}),
    $ctx as PageCtx
  );

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <Head>
        <meta name="twitter:card" content="summary" />
        <title key="title">{pageMetadata.title}</title>
        <meta key="og:title" property="og:title" content={pageMetadata.title} />
        <meta
          key="twitter:title"
          property="twitter:title"
          content={pageMetadata.title}
        />
        <meta
          key="description"
          property="description"
          content={pageMetadata.description}
        />
        <meta
          key="og:description"
          property="og:description"
          content={pageMetadata.description}
        />
        <meta
          key="twitter:description"
          property="twitter:description"
          content={pageMetadata.description}
        />

        <link rel="canonical" href={pageMetadata.alternates?.canonical} />
      </Head>

      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            styleTokensClassNames,
            sty.root
          )}
        >
          <StateProvider
            data-plasmic-name={"isAutoSave"}
            data-plasmic-override={overrides.isAutoSave}
            forceValue={(() => {
              try {
                return (() => {
                  if (typeof window !== "undefined") {
                    const searchParams = new window.URLSearchParams(
                      window.location.search
                    );
                    return (
                      searchParams.get("isAutoSave") ||
                      searchParams.get("isAutosave")
                    );
                  }
                })();
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return undefined;
                }
                throw e;
              }
            })()}
            onChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, ["isAutoSave", "value"]).apply(
                null,
                eventArgs
              );

              (async value => {
                const $steps = {};

                $steps["runCode"] = $state.isAutoSave.value
                  ? (() => {
                      const actionArgs = {
                        customFunction: async () => {
                          return (() => {
                            const description =
                              $state.isAutoSave.value === "1"
                                ? "Your current session has expired.\nAll previously entered data has been saved."
                                : "Your current session has expired.\nPlease Re-Login.";
                            return $ctx.toast.show({
                              id: 1,
                              type: "info",
                              title: "Session Expired",
                              duration: 15000,
                              description: description
                            });
                          })();
                        }
                      };
                      return (({ customFunction }) => {
                        return customFunction();
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["runCode"] != null &&
                  typeof $steps["runCode"] === "object" &&
                  typeof $steps["runCode"].then === "function"
                ) {
                  $steps["runCode"] = await $steps["runCode"];
                }
              }).apply(null, eventArgs);
            }}
            value={generateStateValueProp($state, ["isAutoSave", "value"])}
          />

          <StateProvider
            data-plasmic-name={"isAutoLogin"}
            data-plasmic-override={overrides.isAutoLogin}
            forceValue={(() => {
              try {
                return (() => {
                  if (typeof window !== "undefined") {
                    const searchParams = new window.URLSearchParams(
                      window.location.search
                    );
                    return (
                      searchParams.get("crypt") !== null &&
                      searchParams.get("pageURL") !== undefined
                    );
                  }
                })();
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return undefined;
                }
                throw e;
              }
            })()}
            onChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, ["isAutoLogin", "value"]).apply(
                null,
                eventArgs
              );

              (async value => {
                const $steps = {};

                $steps["runCode"] = $state.isAutoLogin.value
                  ? (() => {
                      const actionArgs = {
                        customFunction: async () => {
                          return (async () => {
                            async function onFinish() {
                              try {
                                $state.isLoggingWithToken = true;
                                const loginResult = await attemptTokenLogin();
                                if (loginResult.factors) {
                                  handleMultiFactorAuth(loginResult);
                                } else if (loginResult.redirect) {
                                  handleRedirect(loginResult);
                                }
                              } catch (error) {
                                handleLoginError(error);
                              }
                            }
                            async function attemptTokenLogin() {
                              const params = new URLSearchParams(
                                window.location.search
                              );
                              const crypt = params.get("crypt");
                              const page = params.get("pageURL");
                              const baseUrl = new URL(
                                "/New/Login.ashx",
                                window.location.href
                              );
                              const fetchUrl = page
                                ? `${baseUrl}?pageURL=${page}`
                                : baseUrl;
                              const response = await fetch(fetchUrl, {
                                method: "POST",
                                body: JSON.stringify({
                                  crypt,
                                  useDefaultFactor: false
                                }),
                                headers: {
                                  "Content-type":
                                    "application/json; charset=UTF-8"
                                }
                              });
                              if (!response.ok) {
                                throw await response.json();
                              }
                              return await response.json();
                            }
                            function handleMultiFactorAuth(loginResult) {
                              $ctx.toast.show({
                                id: 1,
                                type: "info",
                                duration: 5000,
                                title: loginResult.title,
                                description: loginResult.description
                              });
                              const formattedFactors = loginResult.factors.map(
                                f => ({
                                  value: f,
                                  default: f === "Email"
                                })
                              );
                              if (!formattedFactors.some(f => f.default)) {
                                formattedFactors[0].default = true;
                              }
                              const defaultFactor = formattedFactors.find(
                                f => f.default
                              );
                              if (
                                defaultFactor &&
                                formattedFactors.length === 1
                              ) {
                                $state.multiFactorAuthModal.cooldown[
                                  defaultFactor.value
                                ] = 30;
                              }
                              $state.multiFactorAuthModal.factors =
                                formattedFactors;
                              $state.multiFactorAuthModal.methodSelected =
                                formattedFactors.length === 1;
                              $state.multiFactorAuthModal.open = true;
                            }
                            function handleRedirect(loginResult) {
                              let redirectPath = formatRedirectUrl(
                                loginResult.redirect
                              );
                              if (loginResult.mobileAppRedirect) {
                                attemptMobileAppRedirect(redirectPath);
                              } else {
                                window.location.href = `${window.location.origin}${redirectPath}`;
                              }
                            }
                            function formatRedirectUrl(redirectPath) {
                              let formattedPath = redirectPath;
                              if (formattedPath.startsWith("~")) {
                                formattedPath = formattedPath.replace(/^~/, "");
                              }
                              if (!formattedPath.startsWith("http")) {
                                if (!formattedPath.startsWith("/")) {
                                  formattedPath = `/${formattedPath}`;
                                }
                              }
                              return formattedPath;
                            }
                            function attemptMobileAppRedirect(redirectPath) {
                              const params = new URLSearchParams(
                                window.location.search
                              );
                              const crypt = params.get("crypt");
                              const mobileAppUrl = `myevaluations://login?token=${encodeURIComponent(crypt)}&redirect_path=${encodeURIComponent(redirectPath)}`;
                              const startTime = Date.now();
                              window.location.href = mobileAppUrl;
                              $state.mobileAppRedirect = {
                                startTime,
                                webFallbackUrl: `${window.location.origin}${redirectPath}`
                              };
                            }
                            function handleLoginError(errorData) {
                              const params = new URLSearchParams(
                                window.location.search
                              );
                              if (errorData.username) {
                                $state.usernameParam = errorData.username;
                                params.set("username", errorData.username);
                                history.replaceState(
                                  null,
                                  "",
                                  "?" + params.toString()
                                );
                              }
                              if (errorData.redirect) {
                                params.set("redirect", errorData.redirect);
                                history.replaceState(
                                  null,
                                  "",
                                  "?" + params.toString()
                                );
                              }
                              $ctx.toast.show({
                                id: 1,
                                type: "error",
                                duration: 15000,
                                title: errorData.error.title,
                                description: errorData.error.description
                              });
                              $state.isLoggingWithToken = false;
                            }
                            return onFinish();
                          })();
                        }
                      };
                      return (({ customFunction }) => {
                        return customFunction();
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["runCode"] != null &&
                  typeof $steps["runCode"] === "object" &&
                  typeof $steps["runCode"].then === "function"
                ) {
                  $steps["runCode"] = await $steps["runCode"];
                }
              }).apply(null, eventArgs);
            }}
            value={generateStateValueProp($state, ["isAutoLogin", "value"])}
          />

          <DebounceProvider
            data-plasmic-name={"debounceProvider"}
            data-plasmic-override={overrides.debounceProvider}
            className={classNames("__wab_instance", sty.debounceProvider)}
            delay={6000}
            name={"debouncedValue"}
            value={(() => {
              try {
                return $state.mobileAppRedirect;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return undefined;
                }
                throw e;
              }
            })()}
          >
            <DataCtxReader__>
              {$ctx => (
                <OnChangeProvider
                  data-plasmic-name={"webFallbackRedirect"}
                  data-plasmic-override={overrides.webFallbackRedirect}
                  data={(() => {
                    try {
                      return $ctx.debouncedValue;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  deepEqualCheck={true}
                  onChange={async data => {
                    const $steps = {};

                    $steps["runCode"] =
                      $state.isLoggingWithToken && !!data?.webFallbackUrl
                        ? (() => {
                            const actionArgs = {
                              customFunction: async () => {
                                return (() => {
                                  const redirectUrl = data?.webFallbackUrl;
                                  $state.mobileAppRedirect = {};
                                  return (window.location.href = redirectUrl);
                                })();
                              }
                            };
                            return (({ customFunction }) => {
                              return customFunction();
                            })?.apply(null, [actionArgs]);
                          })()
                        : undefined;
                    if (
                      $steps["runCode"] != null &&
                      typeof $steps["runCode"] === "object" &&
                      typeof $steps["runCode"].then === "function"
                    ) {
                      $steps["runCode"] = await $steps["runCode"];
                    }
                  }}
                  runOnMount={false}
                />
              )}
            </DataCtxReader__>
          </DebounceProvider>
          <MultiFactorAuthModal
            data-plasmic-name={"multiFactorAuthModal"}
            data-plasmic-override={overrides.multiFactorAuthModal}
            action={"autologin process"}
            className={classNames("__wab_instance", sty.multiFactorAuthModal)}
            cooldown={generateStateValueProp($state, [
              "multiFactorAuthModal",
              "cooldown"
            ])}
            factors={generateStateValueProp($state, [
              "multiFactorAuthModal",
              "factors"
            ])}
            isChallengeSubmitting={generateStateValueProp($state, [
              "multiFactorAuthModal",
              "isChallengeSubmitting"
            ])}
            methodSelected={generateStateValueProp($state, [
              "multiFactorAuthModal",
              "methodSelected"
            ])}
            onCooldownChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, [
                "multiFactorAuthModal",
                "cooldown"
              ]).apply(null, eventArgs);

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }
            }}
            onFactorsChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, [
                "multiFactorAuthModal",
                "factors"
              ]).apply(null, eventArgs);

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }
            }}
            onIsChallengeSubmittingChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, [
                "multiFactorAuthModal",
                "isChallengeSubmitting"
              ]).apply(null, eventArgs);

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }
            }}
            onMethodSelectedChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, [
                "multiFactorAuthModal",
                "methodSelected"
              ]).apply(null, eventArgs);

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }
            }}
            onOpenChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, [
                "multiFactorAuthModal",
                "open"
              ]).apply(null, eventArgs);

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }

              (async val => {
                const $steps = {};

                $steps["updateIsLoggingWithToken"] =
                  !$state.multiFactorAuthModal.open && $state.isLoggingWithToken
                    ? (() => {
                        const actionArgs = {
                          variable: {
                            objRoot: $state,
                            variablePath: ["isLoggingWithToken"]
                          },
                          operation: 0,
                          value: false
                        };
                        return (({
                          variable,
                          value,
                          startIndex,
                          deleteCount
                        }) => {
                          if (!variable) {
                            return;
                          }
                          const { objRoot, variablePath } = variable;

                          $stateSet(objRoot, variablePath, value);
                          return value;
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                if (
                  $steps["updateIsLoggingWithToken"] != null &&
                  typeof $steps["updateIsLoggingWithToken"] === "object" &&
                  typeof $steps["updateIsLoggingWithToken"].then === "function"
                ) {
                  $steps["updateIsLoggingWithToken"] =
                    await $steps["updateIsLoggingWithToken"];
                }
              }).apply(null, eventArgs);
            }}
            onVerify={async (code, deliveryMethod) => {
              const $steps = {};

              $steps["runCode"] = $state.isAutoLogin.value
                ? (() => {
                    const actionArgs = {
                      customFunction: async () => {
                        return (async () => {
                          async function onVerify() {
                            const params = new URLSearchParams(
                              window.location.search
                            );
                            const crypt = params.get("crypt");
                            const page = params.get("pageURL");
                            const baseUrl = new URL(
                              "/New/Login.ashx",
                              window.location.href
                            );
                            const fetchUrl = page
                              ? `${baseUrl}?pageURL=${page}`
                              : baseUrl;
                            if (code)
                              fetchUrl.searchParams.append("authCode", code);
                            if (deliveryMethod)
                              fetchUrl.searchParams.append(
                                "deliveryMethod",
                                deliveryMethod
                              );
                            const response = await fetch(fetchUrl, {
                              method: "POST",
                              body: JSON.stringify({ crypt: crypt }),
                              headers: {
                                "Content-type":
                                  "application/json; charset=UTF-8"
                              }
                            });
                            if (response.ok) {
                              const responseData = await response.json();
                              if (responseData.title) {
                                $ctx.toast.show({
                                  type: responseData?.factors
                                    ? "info"
                                    : "success",
                                  duration: 5000,
                                  title: responseData.title,
                                  description: responseData.description
                                });
                              }
                              if (responseData.redirect) {
                                let finalDestination = responseData.redirect;
                                if (finalDestination.startsWith("~")) {
                                  finalDestination = finalDestination.replace(
                                    /^~/,
                                    ""
                                  );
                                }
                                if (!finalDestination.startsWith("http")) {
                                  if (!finalDestination.startsWith("/")) {
                                    finalDestination = `/${finalDestination}`;
                                  }
                                  finalDestination = `${window.location.origin}${finalDestination}`;
                                }
                                window.location.href = finalDestination;
                              }
                            } else {
                              const errorData = await response.json();
                              if (errorData.username) {
                                $state.usernameParam = errorData.username;
                                params.set("username", errorData.username);
                                history.replaceState(
                                  null,
                                  "",
                                  "?" + params.toString()
                                );
                              }
                              if (errorData.redirect) {
                                params.set("redirect", errorData.redirect);
                                history.replaceState(
                                  null,
                                  "",
                                  "?" + params.toString()
                                );
                              }
                              $state.multiFactorAuthModal.isChallengeSubmitting = false;
                              $ctx.toast.show({
                                id: 1,
                                type: "error",
                                duration: 5000,
                                title: errorData.error.title,
                                description: errorData.error.description
                              });
                            }
                          }
                          return onVerify();
                        })();
                      }
                    };
                    return (({ customFunction }) => {
                      return customFunction();
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runCode"] != null &&
                typeof $steps["runCode"] === "object" &&
                typeof $steps["runCode"].then === "function"
              ) {
                $steps["runCode"] = await $steps["runCode"];
              }
            }}
            open={generateStateValueProp($state, [
              "multiFactorAuthModal",
              "open"
            ])}
          />

          {(
            hasVariant(globalVariants, "mobile", "mobile")
              ? false
              : hasVariant(globalVariants, "mobile", "tabletPortrait")
                ? false
                : true
          ) ? (
            <div
              data-plasmic-name={"desktop"}
              data-plasmic-override={overrides.desktop}
              className={classNames(projectcss.all, sty.desktop)}
            >
              <div
                data-plasmic-name={"content"}
                data-plasmic-override={overrides.content}
                className={classNames(projectcss.all, sty.content)}
              >
                <News
                  className={classNames("__wab_instance", sty.news__brlyr)}
                />

                <LoginForm
                  data-plasmic-name={"loginForm"}
                  data-plasmic-override={overrides.loginForm}
                  className={classNames("__wab_instance", sty.loginForm)}
                  isLoggingWithToken={(() => {
                    try {
                      return $state.isLoggingWithToken;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return false;
                      }
                      throw e;
                    }
                  })()}
                  onHelpClick={async () => {
                    const $steps = {};

                    $steps["updateLoginTroubleshootingModalOpen"] = true
                      ? (() => {
                          const actionArgs = {
                            variable: {
                              objRoot: $state,
                              variablePath: [
                                "loginTroubleshootingModal",
                                "open"
                              ]
                            },
                            operation: 0,
                            value: true
                          };
                          return (({
                            variable,
                            value,
                            startIndex,
                            deleteCount
                          }) => {
                            if (!variable) {
                              return;
                            }
                            const { objRoot, variablePath } = variable;

                            $stateSet(objRoot, variablePath, value);
                            return value;
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["updateLoginTroubleshootingModalOpen"] != null &&
                      typeof $steps["updateLoginTroubleshootingModalOpen"] ===
                        "object" &&
                      typeof $steps["updateLoginTroubleshootingModalOpen"]
                        .then === "function"
                    ) {
                      $steps["updateLoginTroubleshootingModalOpen"] =
                        await $steps["updateLoginTroubleshootingModalOpen"];
                    }
                  }}
                  usernameParam={(() => {
                    try {
                      return $state.usernameParam;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                />
              </div>
            </div>
          ) : null}
          {(
            hasVariant(globalVariants, "mobile", "mobile")
              ? true
              : hasVariant(globalVariants, "mobile", "tabletPortrait")
                ? true
                : false
          ) ? (
            <div
              data-plasmic-name={"mobile"}
              data-plasmic-override={overrides.mobile}
              className={classNames(projectcss.all, sty.mobile)}
            >
              <LoginForm
                data-plasmic-name={"loginForm2"}
                data-plasmic-override={overrides.loginForm2}
                className={classNames("__wab_instance", sty.loginForm2)}
                isLoggingWithToken={(() => {
                  try {
                    return $state.isLoggingWithToken;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return false;
                    }
                    throw e;
                  }
                })()}
                onHelpClick={async () => {
                  const $steps = {};

                  $steps["updateLoginTroubleshootingModalOpen"] = true
                    ? (() => {
                        const actionArgs = {
                          variable: {
                            objRoot: $state,
                            variablePath: ["loginTroubleshootingModal", "open"]
                          },
                          operation: 0,
                          value: true
                        };
                        return (({
                          variable,
                          value,
                          startIndex,
                          deleteCount
                        }) => {
                          if (!variable) {
                            return;
                          }
                          const { objRoot, variablePath } = variable;

                          $stateSet(objRoot, variablePath, value);
                          return value;
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["updateLoginTroubleshootingModalOpen"] != null &&
                    typeof $steps["updateLoginTroubleshootingModalOpen"] ===
                      "object" &&
                    typeof $steps["updateLoginTroubleshootingModalOpen"]
                      .then === "function"
                  ) {
                    $steps["updateLoginTroubleshootingModalOpen"] =
                      await $steps["updateLoginTroubleshootingModalOpen"];
                  }
                }}
              />

              <News className={classNames("__wab_instance", sty.news__hQebs)} />
            </div>
          ) : null}
          <LoginTroubleshootingModal
            data-plasmic-name={"loginTroubleshootingModal"}
            data-plasmic-override={overrides.loginTroubleshootingModal}
            className={classNames(
              "__wab_instance",
              sty.loginTroubleshootingModal
            )}
            onOpenChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, [
                "loginTroubleshootingModal",
                "open"
              ]).apply(null, eventArgs);

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }
            }}
            open={generateStateValueProp($state, [
              "loginTroubleshootingModal",
              "open"
            ])}
          />

          <ContactModal
            data-plasmic-name={"contactModal"}
            data-plasmic-override={overrides.contactModal}
            className={classNames("__wab_instance", sty.contactModal)}
            onOpenChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, ["contactModal", "open"]).apply(
                null,
                eventArgs
              );

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }
            }}
            open={generateStateValueProp($state, ["contactModal", "open"])}
          />
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "isAutoSave",
    "isAutoLogin",
    "debounceProvider",
    "webFallbackRedirect",
    "multiFactorAuthModal",
    "desktop",
    "content",
    "loginForm",
    "mobile",
    "loginForm2",
    "loginTroubleshootingModal",
    "contactModal"
  ],
  isAutoSave: ["isAutoSave"],
  isAutoLogin: ["isAutoLogin"],
  debounceProvider: ["debounceProvider", "webFallbackRedirect"],
  webFallbackRedirect: ["webFallbackRedirect"],
  multiFactorAuthModal: ["multiFactorAuthModal"],
  desktop: ["desktop", "content", "loginForm"],
  content: ["content", "loginForm"],
  loginForm: ["loginForm"],
  mobile: ["mobile", "loginForm2"],
  loginForm2: ["loginForm2"],
  loginTroubleshootingModal: ["loginTroubleshootingModal"],
  contactModal: ["contactModal"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  isAutoSave: typeof StateProvider;
  isAutoLogin: typeof StateProvider;
  debounceProvider: typeof DebounceProvider;
  webFallbackRedirect: typeof OnChangeProvider;
  multiFactorAuthModal: typeof MultiFactorAuthModal;
  desktop: "div";
  content: "div";
  loginForm: typeof LoginForm;
  mobile: "div";
  loginForm2: typeof LoginForm;
  loginTroubleshootingModal: typeof LoginTroubleshootingModal;
  contactModal: typeof ContactModal;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicLogIn__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicLogIn__VariantsArgs;
    args?: PlasmicLogIn__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicLogIn__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicLogIn__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLogIn__ArgProps,
          internalVariantPropNames: PlasmicLogIn__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLogIn__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLogIn";
  } else {
    func.displayName = `PlasmicLogIn.${nodeName}`;
  }
  return func;
}

export const PlasmicLogIn = Object.assign(
  // Top-level PlasmicLogIn renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    isAutoSave: makeNodeComponent("isAutoSave"),
    isAutoLogin: makeNodeComponent("isAutoLogin"),
    debounceProvider: makeNodeComponent("debounceProvider"),
    webFallbackRedirect: makeNodeComponent("webFallbackRedirect"),
    multiFactorAuthModal: makeNodeComponent("multiFactorAuthModal"),
    desktop: makeNodeComponent("desktop"),
    content: makeNodeComponent("content"),
    loginForm: makeNodeComponent("loginForm"),
    mobile: makeNodeComponent("mobile"),
    loginForm2: makeNodeComponent("loginForm2"),
    loginTroubleshootingModal: makeNodeComponent("loginTroubleshootingModal"),
    contactModal: makeNodeComponent("contactModal"),

    // Metadata about props expected for PlasmicLogIn
    internalVariantProps: PlasmicLogIn__VariantProps,
    internalArgProps: PlasmicLogIn__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/login",
      pagePath: "/login",
      params: {},
      query: {}
    })
  }
);

export default PlasmicLogIn;
/* prettier-ignore-end */
